module.exports = __webpack_public_path__ + "static/media/image-howto-2.8f91acc3.jpg";